module.exports = __webpack_public_path__ + "static/SDP_Logo.30cedc81.png";